import { createContext } from 'react';
import {ID, Response} from '../../../../../_dashboard/helpers'
import { Contact } from '../../../contact-management/contact-details/core/_models';

export interface Footer {
  _id?: ID;
  description?:string;
  contact?:Contact;
  image:string
  seoUrl?:string

}



export const initialFooter: Footer = {


  contact: {
  
    email: '',
    phone: '',
    adress:''
  },
 
  description:'',
  image: '',

};
export type FooterQueryResponse = Response<Array<Footer>>;
export type QueryResponseFooterContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined
  refetchData: () => void
  isLoading: boolean
  query: any
}
export function createFooterResponseContext<T>(initialState: QueryResponseFooterContextProps<T>) {
  return createContext(initialState)
}
export const initialFooterQueryResponse = { refetchData: () => { }, isLoading: false, query: '' }